export const mediaBreakpoints = {
  xs: `280px`,
  sm: `480px`,
  md: `768px`,
  l: `1024px`,
xl:`1290px`,
};
